// Rename ArticleListName to the name of the feature you are creating.

export const RenameArticleList = async () => {
  const wrappersIO: NodeListOf<HTMLDivElement> = document.querySelectorAll(
    '[data-vr-zone="List articles"]'
  );

  const wrappersMrf: NodeListOf<HTMLDivElement> = document.querySelectorAll(
    '[data-mrf-recirculation="List articles"]'
  );

  wrappersIO.forEach((wrapper, index) => {
    wrapper.setAttribute('data-vr-zone', `List articles ${index + 1}`);
  });

  wrappersMrf.forEach((wrapper, index) => {
    wrapper.setAttribute('data-mrf-recirculation', `List articles ${index + 1}`);
  });
};
